import React, { useState } from 'react';
import axios from 'axios';
import { Alert,Typography, TextField, Button, Box, CircularProgress, Snackbar } from '@mui/material';
import { useTheme } from '@mui/material/styles';

const DataSource = ({ toggleSidebar,setSheetData, nodeId, setNodeId, updateNodeWithSourceData }) => {
  // State to hold the user-provided sheet ID
  const [sheetId, setSheetId] = useState('');
  const theme = useTheme();
  const [isLoading, setIsLoading] = useState(false);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: '',
    severity: 'success',
  });
  

  const getSheetData = async () => {
    if (!sheetId) {
      setSnackbar({ open: true, message: 'Please enter a sheet URL',severity: 'warning' });
      return;
    }
  
    const match = sheetId.match(/\/spreadsheets\/d\/([a-zA-Z0-9-_]+)/);
    if (!match || match.length < 2) {
      setSnackbar({ open: true, message: 'Invalid Google Sheet URL',severity: 'error' });
      return;
    }
    const extractedSheetId = match[1];
  
    try {
      setIsLoading(true); // Start loading
  
      const response = await axios.get(`${process.env.REACT_APP_BACK_END_URL}/gsheets/get-sheet-data?sheet_id=${extractedSheetId}`, {
        withCredentials: true,
      });
  
      const data = response.data;
      updateNodeWithSourceData(data, nodeId);
      setSnackbar({ open: true, message: 'Data loaded successfully',severity: 'success' });
    
      console.log(data);
    } catch (error) {
      setSnackbar({ open: true, message: 'Failed to load data' });
      console.error('There was an error fetching the sheet data:', error);
    } finally {
      
      setIsLoading(false); // End loading
      setTimeout(() => {
        toggleSidebar();
      }, 6000);
   
    }
  };
  
  const handleCloseSnackbar = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setSnackbar({ ...snackbar, open: false });
    toggleSidebar()
  };
  


  return (
    <>
      <Typography variant="h5" style={{ color: 'white', marginBottom: '15px' }}>
        Data Source
      </Typography>
  
      {isLoading ? (
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            // Or set to a specific height you prefer
          }}
        >
          <CircularProgress style={{color:'white'}}/> {/* This is the loading indicator */}
        </Box>
      ) : (
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            width: '100%',
          }}
        >
          <TextField
            label="Enter Sheet URL"
            variant="outlined"
            value={sheetId}
            onChange={(e) => setSheetId(e.target.value)}
            fullWidth
            sx={{
              '& .MuiOutlinedInput-input': {
                color: theme.palette.black[100],
              },
              '& .MuiOutlinedInput-root': {
                backgroundColor: theme.palette.white[100],
              },
            }}
          />
          <Button
            onClick={getSheetData}
            style={{ backgroundColor: 'white', color: 'black', marginTop: '10px' }}
            variant="contained"
          >
            Load Data
          </Button>
        </Box>
        
      )}
      <Snackbar
      // anchorOrigin={{ vertical:'bottom', horizontal:'center' }}
      open={snackbar.open}
      autoHideDuration={6000}
      onClose={handleCloseSnackbar}
      message={snackbar.message}

      
    >
      <Alert onClose={handleCloseSnackbar} severity={snackbar.severity}>
    {snackbar.message}
  </Alert>
    </Snackbar>
    </>
  );
  
};

export default DataSource;
